import "./App.css";
import "./index.css";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Sidebar from "./Components/Sidebar";
import Dashboard from "./pages/Dashboard";
import Admins from "./pages/Admins";
import Affiliate from "./pages/Affiliate";
import ModelsManager from "./pages/ModelsManager";
import Users from "./pages/Users";
import Subscription from "./pages/Subscription";
import ProjectManager from "./pages/ProjectManager";
import CreateUser from "./pages/CreateUser";
import Appcreate from "./pages/Appcreate";
import LoginPage from "./Components/LoginPage";
import SubscriotionCuppon501 from "./pages/SubscriotionCuppon501";
import Unitymodels from "./pages/Unitymodels";
import ModalmanagerEdit from "./pages/ModalmanagerEdit";
import CreateManagerForm from "./pages/CreateManagerForm";
import EditProjectManager from "./pages/EditProjectManager";
import CreateAffiliateform from "./pages/CreateAffiliateform";
import AffiliateEditform from "./pages/AffiliateEditform";
import CreateAdminsForm from "./pages/CreateAdminsForm";
import EditAdminsForm from "./pages/EditAdminsForm";
import EditCategoryForm from "./pages/EditCategoryForm";
import CreatePlan from "./pages/CreatePlan";
import EditPlan from "./pages/EditPlan";
import CreateCoupon from "./pages/CreateCoupon";
import EditCoupon from "./pages/EditCoupon";
import UserEditform from "./pages/UserEditform";
import AppCreateEditform from "./pages/AppCreateEditform";

import { useEffect, useState } from "react";
import Context from "./Components/Context";
import AffiliatedDashboard from "./AffiliateDashboard/AffiliatedDashboard";
import AffiliateUsers from "./AffiliateDashboard/Users";
import AffiliateUserEditform from "./AffiliateDashboard/UserEditform";
import SubscriptionCoupon from "./AffiliateDashboard/SubscriotionCuppon501";
import UploadAds from "./pages/UploadAds";
import UploadHelp from "./pages/AppHelp";
import AppFeedback from "./pages/AppFeedback";
import ContactUs from "./pages/ContactUs";
import PayUser from "./pages/PayUser";
import Unitymodals3D from "./pages/Unitymodels3d";
import Model from "./ModelDashboard/Model";
import Modelmain from "./ModelDashboard/Modelmain";
import Search from "./Components/Search";
import RefundPolicy from "./AffiliateDashboard/RefundPolicy";
import PrivacyPolicy from "./AffiliateDashboard/PrivacyPolicy";
import TermsAndConditions from "./AffiliateDashboard/TermsAndConditions";
import PaymentSuccess from "./AffiliateDashboard/PaymentSuccess";
import PaymentFailure from "./AffiliateDashboard/PaymentFailure";
// import PrivacyPolicy from "./Components/PrivacyPolicy";
// import TermsAndConditions from "./Components/TermsAndConditions";
// import Model from "./ModelDashboard/Model";
// import Modelmain from "./ModelDashboard/Modelmain";

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [userType, setUserType] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userType = localStorage.getItem("userType");
    if (token && userType) {
      setAuthenticated(true);
      setUserType(userType);
    } else {
      setAuthenticated(false);
      setUserType("");
    }
  }, []);

  // ADDED CODE TO DYNAMICALLY CHANGE THE DOCUMENT TITLE
  useEffect(() => {
    if (userType === "admin") {
      document.title = "Texpidea Admin";
    } else if (userType === "Affiliate") {
      document.title = "Texpidea Affiliate";
    } else if (userType === "modelmanager") {
      document.title = "Texpidea Model Manager";
    } else {
      document.title = "Texpidea";
    }
  }, [userType]);
  // END OF ADDED CODE

  const handleLogin = (token) => {
    localStorage.setItem("token", token);

    setAuthenticated(true);
  };

  return (
    <>
      <Context>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                authenticated ? (
                  userType === "admin" ? (
                    <Navigate to="/dashboard" />
                  ) : userType === "Affiliate" ? (
                    <Navigate to="/AffiliateDashboard" />
                  ) : userType === "modelmanager" ? (
                    <Navigate to="/modeldashboard/" />
                  ) : null
                ) : (
                  <LoginPage onLogin={handleLogin} />
                )
              }
            />

            {/* Model dashboard */}
            <Route
              path="/modeldashboard/*" // Use /* to allow for nested routes within Modelmain
              element={authenticated ? <Modelmain /> : <Navigate to="/" />}
            />
            {/* model dashboard */}
            <Route
              path="/sidebar"
              element={authenticated ? <Sidebar /> : <Navigate to="/" />}
            />

            {/* Dashboard */}
            <Route
              path="/dashboard"
              element={authenticated ? <Dashboard /> : <Navigate to="/" />}
            />
            {/* search */}
            <Route
              path="/search"
              element={authenticated ? <Search /> : <Navigate to="/" />}
            />

            {/* Admins */}
            <Route
              path="/admins"
              element={authenticated ? <Admins /> : <Navigate to="/" />}
            />
            <Route
              path="/createAdminsForm"
              element={
                authenticated ? <CreateAdminsForm /> : <Navigate to="/" />
              }
            />
            <Route
              path="/admins/:admin_id"
              element={authenticated ? <EditAdminsForm /> : <Navigate to="/" />}
            />
            {/* Users */}
            <Route
              path="/users"
              element={authenticated ? <Users /> : <Navigate to="/" />}
            />
            <Route
              path="/createUser"
              element={authenticated ? <CreateUser /> : <Navigate to="/" />}
            />
            <Route
              path="/users/:user_id"
              element={authenticated ? userType === "admin" ? <UserEditform /> : <AffiliateUserEditform /> : <Navigate to="/" />}
            />
            {/* CreateApp user page in users */}
            <Route
              path="/appcreate"
              element={authenticated ? <Appcreate /> : <Navigate to="/" />}
            />
            <Route
              path="/appCreateEditform"
              element={
                authenticated ? <AppCreateEditform /> : <Navigate to="/" />
              }
            />

            {/* Affiliate */}
            <Route
              path="/affiliate"
              element={authenticated ? <Affiliate /> : <Navigate to="/" />}
            />
            <Route
              path="/createAffiliateform"
              element={
                authenticated ? <CreateAffiliateform /> : <Navigate to="/" />
              }
            />
            <Route
              path="/affiliate/:row_id"
              element={
                authenticated ? <AffiliateEditform /> : <Navigate to="/" />
              }
            />
            {/* Modals Manager */}
            <Route
              path="/modelsManager"
              element={authenticated ? <ModelsManager /> : <Navigate to="/" />}
            />
            <Route
              path="/createManagerForm"
              element={
                authenticated ? <CreateManagerForm /> : <Navigate to="/" />
              }
            />
            <Route
              path="/modelsManager/:modelmanager_id"
              element={
                authenticated ? <ModalmanagerEdit /> : <Navigate to="/" />
              }
            />
            {/* ModelManager501 in Model Manager page */}
            <Route
              path="/unitymodels"
              element={authenticated ? <Unitymodels /> : <Navigate to="/" />}
            />
            <Route
              path="/unitymodels3D"
              element={authenticated ? <Unitymodals3D /> : <Navigate to="/" />}
            />
            <Route
              path="/unitymodel/:video_id"
              element={
                authenticated ? <EditCategoryForm /> : <Navigate to="/" />
              }
            />
            {/* Project Manager */}
            <Route
              path="/projectManager"
              element={authenticated ? <ProjectManager /> : <Navigate to="/" />}
            />
            <Route
              path="/editProjectManager"
              element={
                authenticated ? <EditProjectManager /> : <Navigate to="/" />
              }
            />

            {/* Subscription */}
            <Route
              path="/subscription"
              element={authenticated ? <Subscription /> : <Navigate to="/" />}
            />
            <Route
              path="/createPlan"
              element={authenticated ? <CreatePlan /> : <Navigate to="/" />}
            />
            <Route
              path="/subscription/:plan_id"
              element={authenticated ? <EditPlan /> : <Navigate to="/" />}
            />
            {/* SubscriotionCuppon501 page in Subscription */}
            <Route
              path="/subscriotionCuppon501"
              element={
                authenticated ? <SubscriotionCuppon501 /> : <Navigate to="/" />
              }
            />
            <Route
              path="/createCoupon"
              element={authenticated ? <CreateCoupon /> : <Navigate to="/" />}
            />
            <Route
              path="/subscriotionCuppon501/:cupon_id"
              element={authenticated ? <EditCoupon /> : <Navigate to="/" />}
            />
            {/* AffiliateMain */}
            <Route
              path="/AffiliateDashboard"
              element={authenticated ? <AffiliatedDashboard /> : <Navigate to="/" />}
            />
            <Route
              path="/AffiliateDashboard/users"
              element={authenticated ? <AffiliateUsers /> : <Navigate to="/" />}
            />
            <Route
              path="/AffiliateDashboard/coupons"
              element={authenticated ? <SubscriptionCoupon /> : <Navigate to="/" />}
            />
            <Route
              path="/AffiliateDashboard/refund-policy"
              element={authenticated ? <RefundPolicy /> : <Navigate to="/" />}
            />
            <Route
              path="/AffiliateDashboard/privacy-policy"
              element={authenticated ? <PrivacyPolicy /> : <Navigate to="/" />}
            />
            <Route
              path="/AffiliateDashboard/terms-and-conditions"
              element={authenticated ? <TermsAndConditions /> : <Navigate to="/" />}
            />
            {/* Ads */}
               <Route path="/policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsAndConditions />} />
            <Route
              path="/ads"
              element={authenticated ? <UploadAds /> : <Navigate to="/" />}
            />
            {/* Help */}
            <Route
              path="/apphelp"
              element={authenticated ? <UploadHelp /> : <Navigate to="/" />}
            />
            {/* Feedback */}
            <Route
              path="/appfeedback"
              element={authenticated ? <AppFeedback /> : <Navigate to="/" />}
            />
            {/* Contact Us */}
            <Route
              path="/contactus"
              element={authenticated ? <ContactUs /> : <Navigate to="/" />}
            />
            {/* Pay User */}
            <Route
              path="/payuser"
              element={authenticated ? <PayUser /> : <Navigate to="/" />}
            />
            {/* Payment result pages — public (no auth), called by payment gateway redirects */}
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-failure" element={<PaymentFailure />} />



          </Routes>
        </BrowserRouter>
      </Context>
    </>
  );
}

export default App;
